import { mapGetters } from "vuex";
import Toast from "../Toast/index";
export default {
  name: "EplNewQuickLinks",
  components: { Toast },
  props: ["device"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["quickLinksNewDashboard", "userType", "user"])
  },
  mounted() {
    this.$store.commit("setServiceType", undefined);
    this.$store.dispatch("quickLinksNewDashboard");
  },
  methods: {
    generateSlug(label) {
      var labelArr = label.split(" ");
      return labelArr.join("-").toLowerCase();
    },
    emitEvent(link) {
      this.$store.commit("setServiceType", link.type);
      link.skipTxnCheck ? false : this.$emit("on-click", link.clickUrlPath);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/QuickLinksMobile/component.js